import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINTS } from '@app/constant/api.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferEarnService {

  constructor(
    private http: HttpClient
  ) { }

  public getReferralAmount(activity): Observable<any> {
    return this.http.get(`${API_END_POINTS.WALLET.referral_amt}?scope=investor&activities=${activity}`)
  }
  getMyReferrals(){
    return this.http.get(API_END_POINTS.WALLET.my_rewards)
  }
  getReferralDetails(query){
    return this.http.get(`${API_END_POINTS.WALLET.referral_details}?${query}`)
  }
  getTransactionDeatils(userId?:string){
    if(userId){
      return this.http.get(`${API_END_POINTS.WALLET.transaction_details}/${userId}`)
    }else{
      return this.http.get(API_END_POINTS.WALLET.transaction_details)
    }
  }
  rewardToBank(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.RAZORPAY.bank_account, data)
  }
  getReferralSummary(){
    return this.http.get(API_END_POINTS.WALLET.referral_summary)
  }
  claimReward(data:any): Observable<any> {
    return this.http.post(`${API_END_POINTS.WALLET.payout}`, data)
  }
  claimMultipleReward(data:any): Observable<any>{
    return this.http.post(`${API_END_POINTS.WALLET.mutiple_payout}`,data)
  }
}
